export default __webpack_public_path__ + "static/media/miguel-lopes-29.fe2d77e0.jpg";